// NGX Theme JS

// ── Header offset (fixed nav) ──

function setMainPadding() {
  const wrap = document.getElementById('site-header-wrap');
  const main = document.getElementById('main-content');
  if (wrap && main) main.style.paddingTop = wrap.offsetHeight + 'px';
  if (wrap) document.documentElement.style.setProperty('--header-height', wrap.offsetHeight + 'px');
}
setMainPadding();
window.addEventListener('resize', setMainPadding);

// ── Utilities ──

function formatMoney(cents) {
  const currency = window.shopCurrency || 'USD';
  return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
}

// ── Shopify Cart API ──

async function apiFetch(url, opts) {
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    ...opts
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
  return data;
}

const fetchCart       = () => apiFetch('/cart.js');
const addToCart       = (id, qty, properties) => apiFetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id, quantity: qty, ...(properties ? { properties } : {}) }] }) });
const changeCartLine  = (line, qty) => apiFetch('/cart/change.js', { method: 'POST', body: JSON.stringify({ line, quantity: qty }) });

// ── Cart badge ──

function updateCartBadge(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

// ── Cart Drawer ──

const cartDrawer    = document.getElementById('cart-drawer');
const cartDrawerBody = document.getElementById('cart-drawer-body');
const cartDrawerFooter = document.getElementById('cart-drawer-footer');
const cartDrawerCount = document.getElementById('cart-drawer-count');
const cartDrawerSubtotal = document.getElementById('cart-drawer-subtotal');

function openCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.add('is-open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('is-open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  if (!qvOverlay || !qvOverlay.classList.contains('is-open')) {
    document.body.style.overflow = '';
  }
}

async function refreshCartDrawer() {
  try {
    const cart = await fetchCart();
    renderCartDrawer(cart);
  } catch (_) {}
}

function renderCartDrawer(cart) {
  updateCartBadge(cart.item_count);
  if (cartDrawerCount) {
    cartDrawerCount.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
  }
  if (!cartDrawerBody) return;

  if (cart.item_count === 0) {
    cartDrawerBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
    return;
  }

  const items = cart.items.map((item, i) => {
    const line = i + 1;
    const img = item.image
      ? `<img src="${item.image.replace('.jpg', '_80x80.jpg').replace('.png', '_80x80.png')}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
      : '';
    const variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : '';
    const gamerTag = item.properties && item.properties['Gamer Tag']
      ? `<p class="cart-drawer__item-variant">Gamer Tag: ${escapeHtml(item.properties['Gamer Tag'])}</p>` : '';
    return `
      <li class="cart-drawer__item">
        <div class="cart-drawer__item-img">${img}</div>
        <div class="cart-drawer__item-info">
          <p class="cart-drawer__item-title">${escapeHtml(item.product_title)}</p>
          ${variantLine}
          ${gamerTag}
          <p class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</p>
          <div class="cart-drawer__item-qty">
            <button class="cart-drawer__qty-btn" data-action="decrease" data-line="${line}" aria-label="Decrease quantity">−</button>
            <span class="cart-drawer__qty-num">${item.quantity}</span>
            <button class="cart-drawer__qty-btn" data-action="increase" data-line="${line}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <button class="cart-drawer__item-remove" data-line="${line}" aria-label="Remove ${escapeHtml(item.product_title)}">×</button>
      </li>`;
  }).join('');

  cartDrawerBody.innerHTML = `<ul class="cart-drawer__items">${items}</ul>`;
  if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.total_price);
  if (cartDrawerFooter) cartDrawerFooter.style.display = '';

  cartDrawerBody.querySelectorAll('.cart-drawer__qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.line, 10);
      const qtyEl = btn.closest('.cart-drawer__item-qty').querySelector('.cart-drawer__qty-num');
      const current = parseInt(qtyEl.textContent, 10);
      const next = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      try {
        const updated = await changeCartLine(line, next);
        renderCartDrawer(updated);
      } catch (_) {}
    });
  });

  cartDrawerBody.querySelectorAll('.cart-drawer__item-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      try {
        const updated = await changeCartLine(parseInt(btn.dataset.line, 10), 0);
        renderCartDrawer(updated);
      } catch (_) {}
    });
  });
}

// ── Quick View ──

let qvProduct = null;
let qvSelectedOptions = [];
const qvOverlay = document.getElementById('quick-view-overlay');
const qvContent = document.getElementById('quick-view-content');

function openQuickView(handle) {
  if (!qvOverlay) return;
  qvOverlay.classList.add('is-open');
  qvOverlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  if (qvContent) qvContent.innerHTML = '<div class="quick-view__loading">Loading...</div>';
  fetch(`/products/${handle}.js`, { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(renderQuickView)
    .catch(() => {
      if (qvContent) qvContent.innerHTML = '<div class="quick-view__loading">Unable to load product.</div>';
    });
}

function closeQuickView() {
  if (!qvOverlay) return;
  qvOverlay.classList.remove('is-open');
  qvOverlay.setAttribute('aria-hidden', 'true');
  if (!cartDrawer || !cartDrawer.classList.contains('is-open')) {
    document.body.style.overflow = '';
  }
  qvProduct = null;
  qvSelectedOptions = [];
}

function renderQuickView(product) {
  qvProduct = product;
  qvSelectedOptions = product.options.map(o => o.values[0]);

  const imgHtml = product.featured_image
    ? `<img src="${product.featured_image}" alt="${escapeHtml(product.title)}" loading="lazy">`
    : `<div class="product-card__placeholder" style="height:100%;font-size:56px;opacity:0.4;">NGX</div>`;

  const showOptions = !(product.options.length === 1
    && product.options[0].name === 'Title'
    && product.options[0].values[0] === 'Default Title');

  const optionsHtml = showOptions ? product.options.map((opt, oi) =>
    `<div class="quick-view__option">
       <p class="quick-view__option-label">${escapeHtml(opt.name)}</p>
       <div class="quick-view__option-btns">
         ${opt.values.map(val =>
           `<button class="quick-view__option-btn${val === qvSelectedOptions[oi] ? ' is-active' : ''}"
                    data-opt-index="${oi}" data-value="${escapeHtml(val)}">${escapeHtml(val)}</button>`
         ).join('')}
       </div>
     </div>`
  ).join('') : '';

  const selectedVariant = findSelectedVariant();
  const price = formatMoney(selectedVariant ? selectedVariant.price : product.price_min);
  const available = selectedVariant ? selectedVariant.available : product.available;

  qvContent.innerHTML = `
    <div class="quick-view__image">${imgHtml}</div>
    <div class="quick-view__details">
      ${product.vendor ? `<p class="quick-view__vendor">${escapeHtml(product.vendor)}</p>` : ''}
      <h2 class="quick-view__title">${escapeHtml(product.title)}</h2>
      <p class="quick-view__price" id="qv-price">${price}</p>
      ${showOptions ? `<div class="quick-view__options">${optionsHtml}</div>` : ''}
      <div class="quick-view__qty-wrap">
        <span class="quick-view__qty-label">Qty</span>
        <div class="quick-view__qty-control">
          <button class="quick-view__qty-btn" id="qv-qty-dec" aria-label="Decrease quantity">−</button>
          <input class="quick-view__qty-input" id="qv-qty" type="number" value="1" min="1" max="99" readonly>
          <button class="quick-view__qty-btn" id="qv-qty-inc" aria-label="Increase quantity">+</button>
        </div>
      </div>
      ${!available ? '<p class="quick-view__unavailable-msg">This variant is sold out.</p>' : ''}
      <button class="btn btn-primary quick-view__atc" id="qv-atc"${!available ? ' disabled' : ''}>
        ${available ? 'Add to Cart' : 'Sold Out'}
      </button>
      <p class="quick-view__atc-feedback" id="qv-feedback"></p>
      <a href="${product.url}" class="quick-view__view-full">View Full Product</a>
    </div>`;

  bindQVEvents();
}

function findSelectedVariant() {
  if (!qvProduct) return null;
  return qvProduct.variants.find(v =>
    (qvSelectedOptions[0] === undefined || v.option1 === qvSelectedOptions[0]) &&
    (qvSelectedOptions[1] === undefined || v.option2 === qvSelectedOptions[1]) &&
    (qvSelectedOptions[2] === undefined || v.option3 === qvSelectedOptions[2])
  ) || null;
}

function updateQVState() {
  const v = findSelectedVariant();
  const priceEl = document.getElementById('qv-price');
  const atcBtn  = document.getElementById('qv-atc');
  const unavail = qvContent && qvContent.querySelector('.quick-view__unavailable-msg');

  if (priceEl && v) priceEl.textContent = formatMoney(v.price);
  if (atcBtn) {
    const ok = v && v.available;
    atcBtn.disabled = !ok;
    atcBtn.textContent = ok ? 'Add to Cart' : 'Sold Out';
  }
  if (unavail) unavail.style.display = (v && !v.available) ? '' : 'none';
}

function bindQVEvents() {
  // Option buttons
  qvContent.querySelectorAll('.quick-view__option-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const oi = parseInt(btn.dataset.optIndex, 10);
      qvSelectedOptions[oi] = btn.dataset.value;
      btn.closest('.quick-view__option-btns')
         .querySelectorAll('.quick-view__option-btn')
         .forEach(b => b.classList.toggle('is-active', b.dataset.value === btn.dataset.value));
      updateQVState();
    });
  });

  // Quantity controls
  const qtyInput = document.getElementById('qv-qty');
  document.getElementById('qv-qty-dec')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
  });
  document.getElementById('qv-qty-inc')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = Math.min(99, parseInt(qtyInput.value, 10) + 1);
  });

  // Add to cart
  const atcBtn   = document.getElementById('qv-atc');
  const feedback = document.getElementById('qv-feedback');
  if (atcBtn) {
    atcBtn.addEventListener('click', async () => {
      const variant = findSelectedVariant();
      if (!variant || !variant.available) return;
      const qty = parseInt(document.getElementById('qv-qty')?.value || '1', 10);
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';
      if (feedback) feedback.textContent = '';
      try {
        await addToCart(variant.id, qty);
        atcBtn.textContent = 'Added!';
        setTimeout(() => { closeQuickView(); openCartDrawer(); }, 500);
      } catch (err) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
        if (feedback) feedback.textContent = err.message;
      }
    });
  }
}

// ── Escape HTML ──

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// ── DOMContentLoaded: wire up all events ──

document.addEventListener('DOMContentLoaded', () => {

  // Mobile nav toggle
  const hamburger = document.querySelector('.hamburger');
  const nav = document.querySelector('.site-nav');
  if (hamburger && nav) {
    hamburger.addEventListener('click', () => {
      nav.classList.toggle('nav-open');
      hamburger.classList.toggle('is-active');
    });
  }

  // Search bar toggle
  const searchToggle = document.getElementById('search-toggle');
  const searchBar = document.getElementById('search-bar');
  const searchClose = document.getElementById('search-close');
  function openSearchBar() {
    if (!searchBar) return;
    searchBar.classList.add('is-open');
    searchToggle?.setAttribute('aria-expanded', 'true');
    searchBar.querySelector('.search-bar__input')?.focus();
  }
  function closeSearchBar() {
    if (!searchBar) return;
    searchBar.classList.remove('is-open');
    searchToggle?.setAttribute('aria-expanded', 'false');
  }
  searchToggle?.addEventListener('click', () => {
    searchBar?.classList.contains('is-open') ? closeSearchBar() : openSearchBar();
  });
  searchClose?.addEventListener('click', closeSearchBar);

  // Cart icon → open drawer (intercept navigation)
  document.querySelector('.cart-icon')?.addEventListener('click', e => {
    e.preventDefault();
    openCartDrawer();
  });

  // Cart drawer close
  document.getElementById('cart-drawer-close')?.addEventListener('click', closeCartDrawer);
  document.getElementById('cart-drawer-overlay')?.addEventListener('click', closeCartDrawer);

  // Quick view close
  document.getElementById('quick-view-close')?.addEventListener('click', closeQuickView);
  qvOverlay?.addEventListener('click', e => {
    if (e.target === qvOverlay) closeQuickView();
  });

  // Quick view trigger (delegated so it works for dynamically loaded content too)
  document.addEventListener('click', e => {
    const btn = e.target.closest('.product-card__quick-view');
    if (btn) { e.preventDefault(); openQuickView(btn.dataset.handle); }
  });

  // Swatch hover → swap card thumbnail (delegated)
  document.addEventListener('mouseover', e => {
    const swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;
    const card = swatch.closest('.product-card');
    const img = card && card.querySelector('.product-card__image-primary');
    if (!img || !swatch.dataset.swatchImage) return;
    if (!img.dataset.originalSrc) img.dataset.originalSrc = img.src;
    img.src = swatch.dataset.swatchImage;
  });
  document.addEventListener('mouseout', e => {
    const swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;
    const card = swatch.closest('.product-card');
    const img = card && card.querySelector('.product-card__image-primary');
    if (img && img.dataset.originalSrc) img.src = img.dataset.originalSrc;
  });

  // Size guide modal
  const sizeGuideOverlay = document.getElementById('size-guide-overlay');
  const sizeGuideTrigger = document.getElementById('size-guide-trigger');
  const sizeGuideClose   = document.getElementById('size-guide-close');

  function openSizeGuide() {
    if (!sizeGuideOverlay) return;
    sizeGuideOverlay.classList.add('is-open');
    sizeGuideOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    if (!sizeGuideOverlay) return;
    sizeGuideOverlay.classList.remove('is-open');
    sizeGuideOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  sizeGuideTrigger?.addEventListener('click', openSizeGuide);
  sizeGuideClose?.addEventListener('click', closeSizeGuide);
  sizeGuideOverlay?.addEventListener('click', e => {
    if (e.target === sizeGuideOverlay) closeSizeGuide();
  });

  // Size guide unit toggle (inches / cm)
  const unitBtnIn = document.getElementById('size-guide-unit-in');
  const unitBtnCm = document.getElementById('size-guide-unit-cm');
  const imgIn = document.getElementById('size-guide-img-in');
  const imgCm = document.getElementById('size-guide-img-cm');

  function setSizeGuideUnit(unit) {
    const isIn = unit === 'in';
    if (imgIn) imgIn.style.display = isIn ? '' : 'none';
    if (imgCm) imgCm.style.display = isIn ? 'none' : '';
    unitBtnIn?.classList.toggle('is-active', isIn);
    unitBtnCm?.classList.toggle('is-active', !isIn);
    unitBtnIn?.setAttribute('aria-selected', isIn);
    unitBtnCm?.setAttribute('aria-selected', !isIn);
  }
  unitBtnIn?.addEventListener('click', () => setSizeGuideUnit('in'));
  unitBtnCm?.addEventListener('click', () => setSizeGuideUnit('cm'));

  // Escape key closes top-most overlay
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (sizeGuideOverlay?.classList.contains('is-open')) closeSizeGuide();
    else if (qvOverlay?.classList.contains('is-open')) closeQuickView();
    else if (cartDrawer?.classList.contains('is-open')) closeCartDrawer();
    else if (searchBar?.classList.contains('is-open')) closeSearchBar();
  });

  // Localization / currency disclosure
  document.querySelectorAll('.disclosure').forEach(disclosure => {
    const toggle = disclosure.querySelector('[data-disclosure-toggle]');
    const input = disclosure.querySelector('[data-disclosure-input]');
    toggle?.addEventListener('click', () => {
      const isOpen = disclosure.hasAttribute('data-open');
      document.querySelectorAll('.disclosure[data-open]').forEach(d => d.removeAttribute('data-open'));
      if (!isOpen) disclosure.setAttribute('data-open', '');
    });
    disclosure.querySelectorAll('[data-disclosure-option]').forEach(option => {
      option.addEventListener('click', e => {
        e.preventDefault();
        if (input) input.value = option.dataset.value;
        disclosure.closest('form')?.submit();
      });
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.disclosure')) {
      document.querySelectorAll('.disclosure[data-open]').forEach(d => d.removeAttribute('data-open'));
    }
  });

  // ── Product page ──
  initProductPage();
});

function initProductPage() {
  const jsonEl = document.getElementById('ProductJson');
  if (!jsonEl) return;

  const product = JSON.parse(jsonEl.textContent);
  let selectedOptions = product.variants[0] ? product.variants[0].options.slice() : [];

  const personalizationOpt = (product.options || []).find(o => o.name === 'Gamer Tag');
  const personalizationIdx = personalizationOpt ? personalizationOpt.position - 1 : -1;
  const gamerTagInput = document.getElementById('product-gamer-tag-input');
  const gamerTagConfirmBtn = document.getElementById('product-gamer-tag-confirm');
  const gamerTagStatus = document.getElementById('product-gamer-tag-status');
  let gamerTagConfirmed = false;

  function applyVariant(variant) {
    if (!variant) return;

    const priceEl = document.getElementById('product-price');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    const idInput = document.getElementById('product-variant-id');
    if (idInput) idInput.value = variant.id;

    const atcBtn = document.getElementById('product-atc');
    if (atcBtn) {
      const ok = variant.available;
      atcBtn.disabled = !ok;
      atcBtn.textContent = ok ? 'Add to Cart' : 'Sold Out';
    }

    if (variant.featured_image) {
      const galleryImg = document.getElementById('product-gallery-img');
      if (galleryImg) {
        const src = variant.featured_image.src;
        galleryImg.src = src + (src.includes('?') ? '&' : '?') + 'width=900';
        galleryImg.alt = variant.featured_image.alt || galleryImg.alt;
      }
      document.querySelectorAll('.product-gallery__thumb').forEach(t => {
        t.classList.toggle('is-active', t.dataset.src && t.dataset.src.split('?')[0] === variant.featured_image.src.split('?')[0]);
      });
    }
  }

  function findVariant() {
    return product.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i])) || null;
  }

  function setGamerTagConfirmed(confirmed) {
    gamerTagConfirmed = confirmed;
    if (gamerTagInput) gamerTagInput.readOnly = confirmed;
    if (gamerTagConfirmBtn) {
      gamerTagConfirmBtn.textContent = confirmed ? 'Edit' : 'Confirm';
      gamerTagConfirmBtn.classList.toggle('is-confirmed', confirmed);
    }
    if (gamerTagStatus) {
      gamerTagStatus.textContent = confirmed
        ? 'Gamer tag confirmed (+€15 added).'
        : 'Optional. Leave blank for no personalization. Max 20 characters — confirm before adding to cart.';
      gamerTagStatus.classList.toggle('is-confirmed', confirmed);
    }
  }

  gamerTagConfirmBtn?.addEventListener('click', () => {
    if (gamerTagConfirmed) {
      setGamerTagConfirmed(false);
      if (personalizationIdx !== -1) {
        selectedOptions[personalizationIdx] = 'None';
        applyVariant(findVariant());
      }
      gamerTagInput?.focus();
      return;
    }

    const hasText = gamerTagInput && gamerTagInput.value.trim();
    if (personalizationIdx !== -1) {
      selectedOptions[personalizationIdx] = hasText ? 'Custom' : 'None';
      applyVariant(findVariant());
    }
    setGamerTagConfirmed(true);
  });

  // Gallery thumbnails
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const img = document.getElementById('product-gallery-img');
      if (img) { img.src = thumb.dataset.src; img.alt = thumb.dataset.alt || ''; }
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // Variant selection → sync ID + price + button state
  document.querySelectorAll('.variant-buttons').forEach(group => {
    group.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const optIdx = parseInt(group.dataset.optionIndex, 10) - 1;
        selectedOptions[optIdx] = btn.dataset.value;

        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        applyVariant(findVariant());
      });
    });
  });

  // Quantity controls
  const qtyInput = document.getElementById('product-qty-input');
  document.getElementById('product-qty-dec')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
  });
  document.getElementById('product-qty-inc')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = Math.min(99, parseInt(qtyInput.value, 10) + 1);
  });

  // AJAX add-to-cart — intercept form submit, open cart drawer
  const form = document.getElementById('product-form');
  const atcBtn = document.getElementById('product-atc');
  if (form && atcBtn) {
    form.addEventListener('submit', async e => {
      e.preventDefault();

      if (gamerTagInput && gamerTagInput.value.trim() && !gamerTagConfirmed) {
        if (gamerTagStatus) gamerTagStatus.textContent = 'Please confirm your gamer tag before adding to cart.';
        gamerTagInput.focus();
        return;
      }

      const variantId = parseInt(document.getElementById('product-variant-id').value, 10);
      const qty = parseInt(qtyInput?.value || '1', 10);
      const properties = (gamerTagInput && gamerTagInput.value.trim())
        ? { 'Gamer Tag': gamerTagInput.value.trim() }
        : null;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      try {
        await addToCart(variantId, qty, properties);
        atcBtn.textContent = 'Added!';
        setTimeout(() => {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
          openCartDrawer();
        }, 500);
      } catch (err) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
      }
    });
  }
}
